$(document).ready(function () {
    let mql = window.matchMedia('(max-width: 600px)').matches;

    // FOR ADA ISSUE

    if (mql) {
        $('.footer-social-links').appendTo('.mobile-social')
    }

    $(".nav-menu-item.has-megamenu").hover(
        function () {
            $(this).attr('aria-expanded', 'true')
        }, function () {
            $(this).attr('aria-expanded', 'false')
        }
    );

    $('a[data-target="#whySubscribeModal"]').on('click', function () {
        setTimeout(() => {
            $('.whysubsmodal .modal-content').focus();
        }, 200);
    })

    $('a[data-target="#subscriptionPolicyModal"]').on('click', function () {
        console.log($('.subscription-policy-modal .modal-content'));
        setTimeout(() => {
            $('.subscription-policy-modal .modal-content').focus();
        }, 200);
    })

    $('.hmbr').on('click', function () {
        setTimeout(() => {
            $('.nav-menu.mob #nav-menu-list li:first-child a')[0].focus()
        }, 100);
    })

    $('.product_care.slick-slider .slick-arrow').on('click', function () {
        setTimeout(() => {
            $(this).closest('.slick-slider').find('.product_care_item.slick-active').focus();
        }, 100);
    })

    var onReviews = document.querySelector('.mob-reviews-center') || false;
    if (onReviews) {
        var flagReviews = false;
        var intervalReviews = setInterval(() => {
            if (!flagReviews) {
                if ($('.bv_main_container').length) {
                    flagReviews = true;
                }
            } else {
                $('.mob-reviews-center .bv_stars_component_container').attr('tabindex', '0')
                $('.bv_main_container').attr('tabindex', '0')
                $('.bv_button_buttonMinimalist').attr({ tabindex: "0", "aria-label": "Write a Review opens a dialog box" })
                $('.bv_button_buttonFull').attr('tabindex', '0')
                $('.bv-fieldsets input.bv-search-text').attr('tabindex', '0')
                $('.bv-fieldsets button.content-search-btn').attr('tabindex', '0')
                $('.bv-secondary-rating-summary-id').attr('aria-hidden', 'false')
                $('.bv-secondary-rating-summary-rating').attr('aria-hidden', 'false')
                $('.bv-searchbar').attr('aria-hidden', 'true')
                $('.bv_stars_component_container').on('mouseover', function () {
                    setTimeout(() => {
                        $('.bv_modal_outer_content').focus();
                    }, 100);
                })

                clearInterval(intervalReviews);
            }
        }, 1300);
    }

    var onInsideStory = document.querySelector('.product-detail-inside-story') || false;
    if (onInsideStory && mql) {
        var items = onInsideStory.querySelectorAll('p')

        items.forEach(item => {
            item.setAttribute('role', 'text')
        })
    }

    var onWhyObsessed = document.querySelector('.product-detail-why-obsessed') || false;
    if (onWhyObsessed && mql) {
        var headings = onWhyObsessed.querySelectorAll('h3.lightpink-text');

        headings.forEach(item => {
            item.setAttribute('aria-label', `${item.textContent} expandable link`)
        })
    }

    var onDetailObsessed = document.querySelector('.product-detail-obsessed') || false;

    if (onDetailObsessed && mql) {
        var buttons = onDetailObsessed.querySelectorAll('button.slick-arrow');
        console.log(buttons);
        buttons.forEach(button => {
            button.addEventListener('click', e => {
                onDetailObsessed.querySelector('.slick-active').focus();
                console.log(onDetailObsessed.querySelector('.slick-active'));
            })
        });
    }


    // FOR ADA ISSUE

    $('.hmbr').click(function () {
        $("#header").toggleClass('bg-white');
    });


    if (mql) {
        // HEADER MOBILE

        const menus = document.querySelectorAll('.megamenu-left .inner-leftgrid-item')

        menus.forEach(menu => {
            const button = menu.querySelector('.heading_left');

            button.addEventListener('click', () => {
                menu.classList.toggle('open');
            })
        });

        // FOOTER MOBILE

        const fmenus = document.querySelectorAll('.mobile-acc')
        const attrToggle = (el, attr) => el.getAttribute(attr) == 'false' ? el.setAttribute(attr, "true") : el.setAttribute(
            attr, "false")
        fmenus.forEach(menu => {
            const button = menu.querySelector('h3');

            button.addEventListener('click', () => {
                menu.classList.toggle('open');
                attrToggle(menu, 'aria-expanded')
            })
        });

    }
    // PARTNERS
    $(".Home__partners__list").slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 6,
        arrows: true,
        prevArrow: `<button class="partners-prev" aria-label="previous"><svg  width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.1498 12.2517L2 12.2517" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.5749 1.67627L2 12.2512L12.5749 22.8261" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>
            `,
        nextArrow: `<button class="partners-next" aria-label="next"><svg  width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.85021 12.2517L23 12.2517" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.4251 1.67627L23 12.2512L12.4251 22.8261" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>
            `,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 1180,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                }
            }
        ]
    });

    if(!mql) {
        setTimeout(() => {
            $('.Home__partners__list .Home__partners__list--item').attr({'aria-hidden': 'false'})
        }, 100);
    }

    $('.Home__partners__list.slick-slider .slick-arrow').on('click', function () {
        setTimeout(() => {
            $(this).closest('.slick-slider').find('.slick-active').focus();
        }, 100);
    })



    // CATEGORIES

    if (mql) {
        var elems = $('.Home__categories__list .Home__categories__list--item');
        elems.sort((a, b) => $(a).data("order") - $(b).data("order")).appendTo(elems.parent());
    }

    var catCarousel = $(".Home__categories__list")
    catCarousel.owlCarousel({
        items: 1.55,
        dots: false,
        center: true,
        loop: true,
        margin: 22,
        nav: false,
        responsive: {
            768: {
                items: 6,
                margin: 10,
                center: false,
            },
            1441: {
                items: 6,
                center: false,
                margin: 25,
            }
        },
        onInitialized: function () {
            $('.Home__categories__list').find('.owl-item').attr({'aria-selected': 'false', 'aria-hidden': 'true'});
            if(mql) {
                $('.Home__categories__list').find('.owl-item.active.center').attr({'aria-selected': 'true', 'aria-hidden': 'false'});
            } else {
                $('.Home__categories__list').find('.owl-item.active').attr({'aria-selected': 'true', 'aria-hidden': 'false'});
            }
        },
    });

    catCarousel.on('changed.owl.carousel', function(event) {
        setTimeout(() => {
            $('.Home__categories__list').find('.owl-item').attr({'aria-selected': 'false', 'aria-hidden': 'true'});
            if(mql) {
                $('.Home__categories__list').find('.owl-item.active.center').attr({'aria-selected': 'true', 'aria-hidden': 'false'}).focus();
            } else {
                $('.Home__categories__list').find('.owl-item.active').attr({'aria-selected': 'true', 'aria-hidden': 'false'}).focus();
            }
        }, 100);
    })

    $('.Home__categories__slide .owl-nav button').attr('role', 'tab')
    $('.Home__categories__slide .owl-nav button').attr('aria-controls', 'categories-nav')

    $('.Home__categories__slide .owl-nav button.owl-next').click(function () {
        catCarousel.trigger('next.owl.carousel');
    })
    $('.Home__categories__slide .owl-nav button.owl-prev').click(function () {
        catCarousel.trigger('prev.owl.carousel');
    })

    var firstLastOpactiy = () => {
        setTimeout(() => {
            var owlCarouselActive = $('.Home__categories__list .owl-item.active')
            owlCarouselActive.each(function (index, value) {
                var isLastElement = index == owlCarouselActive.length - 1;

                if (!mql) {
                    if (isLastElement) {
                        $(this).addClass('opa')
                    } else if (index == 0) {
                        $(this).addClass('opa')
                    } else {
                        $(this).removeClass('opa')
                    }
                }

            })
        }, 100);
    }

    catCarousel.on('changed.owl.carousel', function (event) {
        firstLastOpactiy();
    })

    firstLastOpactiy();

    // STORIES

    var storiesCarousel = $(".Home__stories__wrapper .owl-carousel")
    storiesCarousel.owlCarousel({
        items: 1,
        loop: true,
        dots: false,
        nav: true,
        navText: [`<span hidden>prev</span><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.0014 12.0807L1.85156 12.0807" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.4265 1.50549L1.85156 12.0804L12.4265 22.6553" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>        
        `, `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.85021 12.2926L23 12.2926" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.4251 1.71741L23 12.2923L12.4251 22.8672" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>        
        `],
        responsive: {
            768: {
                items: 4,
                margin: 10
            },
            1441: {
                items: 4,
                margin: 24
            }
        }
    });

    var onQuizSection = document.querySelector('.Home__quizzes' || false);

    if (mql && onQuizSection) {
        var quizButtons = document.querySelectorAll('.Home__quizzes__quiz--btn');

        quizButtons.forEach(el => {
            el.textContent = el.textContent.replace('the', '');
        })
    }


    // BlOG
    var onBlogSection = document.querySelector('.Home__blog' || false);


    if (mql && onBlogSection) {

        var blogCarousel = $(".Home__blog__list")
        blogCarousel.addClass('owl-carousel owl-theme');
        blogCarousel.owlCarousel({
            items: 1,
            loop: false,
            nav: false,
            onInitialized: function (event) {
                $('.Home__blog__list').find('.owl-item').attr({'aria-selected': 'false', 'aria-hidden': 'true', 'tabindex': '-1'});
                $('.Home__blog__list').find('.owl-item.active').attr({'aria-selected': 'true', 'aria-hidden': 'false', 'tabindex': '0'});
            }
        });

        blogCarousel.on('changed.owl.carousel', function(event) {
            setTimeout(() => {
                $('.Home__blog__list').find('.owl-item').attr({'aria-selected': 'false', 'aria-hidden': 'true', 'tabindex': '-1'});
                $('.Home__blog__list').find('.owl-item.active').attr({'aria-selected': 'true', 'aria-hidden': 'false', 'tabindex': '0'}).focus();
                }, 100);
        })
        $('.Home__blog__inner .owl-button.owl-next').click(function () {
            blogCarousel.trigger('next.owl.carousel');
        })
        $('.Home__blog__inner .owl-button.owl-prev').click(function () {
            blogCarousel.trigger('prev.owl.carousel');
        })
    }

    if (mql) {
        $(".Home__yesno__wrapper .yes-wrapper").slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            prevArrow: `<svg class="partners-prev" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.1498 12.2517L2 12.2517" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.5749 1.67627L2 12.2512L12.5749 22.8261" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                `,
            nextArrow: `<svg class="partners-next" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.85021 12.2517L23 12.2517" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.4251 1.67627L23 12.2512L12.4251 22.8261" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                `
        });
    }

});

window.onload = (event) => {
    window.dispatchEvent(new Event('resize'));
};